/* eslint-disable react/no-find-dom-node */
import React                      from 'react';
import PropTypes                  from 'prop-types';
import GridItem                   from '~/components/GridItem';
import GridContainer              from '~/components/GridContainer';
import PaperTop                   from './PaperTop';
import RouteMap                   from './RouteMap';
import EventEvents                from './EventEvents';
import EventStats                 from './EventStats';
import EventRecord                from '~/records/EventRecord';

function ItemEvent({loading, record, geolocations}){
  return(
    <>
      <PaperTop record={record} loading={loading}/>
      <GridContainer>
        <GridItem md={8} xs={12}>
          {!loading && geolocations.length > 0 && <RouteMap record={record} loading={loading} geolocations={geolocations} />}
        </GridItem>
        <GridItem md={4} xs={8}>
          {!loading && <EventEvents record={record} loading={loading} />}
          {!loading && <EventStats record={record} loading={loading} />}
        </GridItem>
      </GridContainer>
    </>
  );
}

ItemEvent.propTypes={
  loading: PropTypes.bool,
  record: PropTypes.instanceOf(EventRecord).isRequired,
  geolocations: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]).isRequired,
};

export default ItemEvent;
